import { render, staticRenderFns } from "./petunjukPreTest.vue?vue&type=template&id=d5969dbe"
import script from "./petunjukPreTest.vue?vue&type=script&lang=js"
export * from "./petunjukPreTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports